import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-335d1f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "profile__nav-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserStatistics = _resolveComponent("UserStatistics", true)!
  const _component_UserCourses = _resolveComponent("UserCourses")!
  const _component_UserEvents = _resolveComponent("UserEvents")!
  const _component_TrainingIndication = _resolveComponent("TrainingIndication")!
  const _component_FavoriteTraining = _resolveComponent("FavoriteTraining")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", null, [
      _createElementVNode("select", {
        class: "profile__search",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToOption && _ctx.navigateToOption(...args))),
        value: _ctx.selectedOption
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            value: option.param
          }, _toDisplayString(option.name), 9, _hoisted_3))
        }), 128))
      ], 40, _hoisted_2),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleOptions, (option, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([
            _ctx.$route.params.option === option.param ? 'selected' : 'closed',
            { statistics: option.param === 'chart' }
          ])
          }, [
            _createVNode(_component_router_link, {
              to: { name: 'statistics', params: { option: option.param } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2))
        }), 128))
      ])
    ]),
    (_ctx.$route.params.option === 'chart')
      ? (_openBlock(), _createBlock(_component_UserStatistics, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.$route.params.option === 'courses')
      ? (_openBlock(), _createBlock(_component_UserCourses, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.$route.params.option === 'events')
      ? (_openBlock(), _createBlock(_component_UserEvents, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.$route.params.option === 'indication')
      ? (_openBlock(), _createBlock(_component_TrainingIndication, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.$route.params.option === 'favorite')
      ? (_openBlock(), _createBlock(_component_FavoriteTraining, { key: 4 }))
      : _createCommentVNode("", true)
  ]))
}